
import { BsXCircleFill } from "react-icons/bs";
import "./style.css";

function CloseButton({ className = "", onClick, style = {} }) {
    return (
        <div id="custom-close-button" style={style} className={className} onClick={() => {
            onClick();
        }}>
            <div style={true ? { backgroundColor: "#fff" } : {}}>
                <BsXCircleFill className="c-icon" />
            </div>
        </div>
    );
}

export default CloseButton;